import type { FilterButtonProps } from './Filter.types';

export function FilterButton(props: FilterButtonProps) {
  const { label, isActive, onClick } = props;

  const activeClassName = isActive
    ? 'bg-pmw-fc-brand080-light dark:bg-pmw-fc-brand120-dark border-pmw-s-brand-light dark:border-pmw-s-brand-dark text-pmw-label-primary-light dark:text-pmw-label-primary-dark'
    : 'border-transparent text-pmw-label-secondary-light dark:text-pmw-label-secondary-dark';

  return (
    <button
      type="button"
      className={`py-[8px] px-[12px] flex-1 border rounded-full truncate cursor-pointer ${activeClassName}`}
      onClick={onClick}
    >
      {label}
    </button>
  );
}
